module.exports = __webpack_public_path__ + "static/media/money.61dad495.svg";